import { Route } from "lucide-react";
import type { HomeLocation } from "../lib/ai-chat";
import type { PlaceForecast } from "../lib/weather";
import { googleMapsDirections } from "../lib/google-maps";

export function GoogleMapsLink({ place, home }: { place: PlaceForecast; home?: HomeLocation }) {
  const label = home ? `Percorso da casa a ${place.name} su Google Maps` : `Apri il percorso per ${place.name} su Google Maps e scegli la partenza`;
  return <a className="icon-button maps-directions" href={googleMapsDirections(place, home)} target="_blank" rel="noopener noreferrer" aria-label={label} data-tooltip={label}><Route /></a>;
}
